<template>
  <div class="arm-contract-trigger">
    <div class="arm-contract">
      <div class="arm-ribbon">
        <div class="box"></div>
        <Arm />
        <Ribbon />
      </div>
      <div class="arm-contract-circle"></div>
      <Contract />
    </div>
  </div>
</template>

<script>
import { TimelineMax, Power1 } from 'gsap'
import Arm from './Arm'
import Contract from './Contract'
import Ribbon from './Ribbon'

export default {
  name: 'ArmContract',
  components: {
    Arm,
    Contract,
    Ribbon
  },
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '.arm-contract-trigger'
    })

    const timeline = new TimelineMax()
      .fromTo('.arm-ribbon', 1, {
        x: '-335px'
      }, {
        x: '-150px'
      }, 0)
      .to('.chapter-2-panel-2', 1, {
        color: '#fff'
      }, 1.5)
      .to('.arm-contract-circle', 1, {
        ease: Power1.easeNone,
        opacity: 1,
        scale: 10
      }, 1.5)

    this.$scrollmagic.addScene(
      scene.setTween(timeline)
    )
  }
}
</script>

<style lang="scss" scoped>
.arm-contract {
  margin: 0 auto 50px;
  padding: 100px 0;
  position: relative;
  text-align: center;

  @media (min-width: 768px) {
    padding: 150px 0;
  }
}

.arm-ribbon {
  position: absolute;
  z-index: 2;
  left: -15px;
  bottom: 85px;

  @media (min-width: 768px) {
    left: 110px;
    bottom: 145px;
  }
}

.box {
  z-index: 2;
  height: 70px;
  width: 9999px;
  background-color: black;
  left: -9999px;
  position: absolute;
}

.arm {
  position: relative;
  z-index: 2;
}

.ribbon {
  position: absolute;
  z-index: 3;
  top: -10px;
  right: -40px;
}

.arm-contract-circle {
  position: absolute;
  width: 270px;
  height: 270px;
  background-color: $c-red;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%) scale(1);
  left: 0;
  right: 0;
  margin: 0 auto;
}

.contract {
  margin: 0 auto;
  position: relative;
}
</style>
